import Styled from './IconButtonStyles'
import { Delete } from '../ontego-ui/sap_icons';

const DeleteIconButton = props => {
    const { onClick } = props

    return (
        <Styled.DeleteIconButton onClick={onClick}>
            <Delete />
        </Styled.DeleteIconButton >
    )
}

export default DeleteIconButton;